<div class="modal-header">
  <h4 class="modal-title">{{ 'header.options.show_technical_info_properties' | translate }}</h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    @if (languages().length > 0) {
      <app-dropdown [items]="languages()" [label]="'header.options.language' | translate" [(selectedItem)]="language"></app-dropdown>
    }
    <app-table [data]="technicalProperties()">
      <app-table-column [header]="'managePropertiesDef.title' | translate" [width]="'auto'">
        <ng-template let-row>{{ row.propertyDefinitionName }}</ng-template>
      </app-table-column>
      <app-table-column [header]="'managePropertiesDef.propertyName' | translate" [width]="'auto'">
        <ng-template let-row>{{ row.name }}</ng-template>
      </app-table-column>
      <app-table-column [header]="'managePropertiesDef.propertyValue' | translate" [width]="'auto'">
        <ng-template let-row>{{ row.value }}</ng-template>
      </app-table-column>
      <app-table-column [header]="'managePropertiesDef.propertyUnit' | translate" [width]="'auto'">
        <ng-template let-row>{{ row.unit }}</ng-template>
      </app-table-column>
      <app-table-column [header]="'managePropertiesDef.propertyType' | translate" [width]="'auto'">
        <ng-template let-row>{{ row.type }}</ng-template>
      </app-table-column>
    </app-table>
  </div>
</div>

<div class="modal-footer d-flex flex-column">
  <div class="d-flex flex-row">
    <button class="btn btn-secondary btn-cancel mx-1" (click)="close()">
      {{'global.label.close' | translate}}
    </button>
  </div>
</div>
